import { render, staticRenderFns } from "./MotoroilGroup.vue?vue&type=template&id=cff33706&"
import script from "./MotoroilGroup.vue?vue&type=script&lang=js&"
export * from "./MotoroilGroup.vue?vue&type=script&lang=js&"
import style0 from "./MotoroilGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports